import React from 'react';
import { TooltipProps } from 'recharts';

import { StyledLegendIcon } from '../styled';
import { countPercent, formatDeviceName } from '../utils';
import { StyledContentTooltip, StyledItemName, StyledTooltipContainer, StyledTooltipTitle } from './styled';

type Props = TooltipProps<number, string> & {
  total: number;
  title: string;
  metricName?: string;
};

const CustomTooltip = ({ payload, active, total, title, metricName = '' }: Props): JSX.Element | null => {
  if (active && payload && payload[0]) {
    return (
      <StyledTooltipContainer>
        <StyledTooltipTitle>{title}</StyledTooltipTitle>
        <StyledContentTooltip>
          <StyledItemName>
            <StyledLegendIcon $color={payload[0].payload.fill}></StyledLegendIcon>
            {formatDeviceName(payload[0].name)}:
          </StyledItemName>
          <div>
            {payload[0].value} {metricName} ({countPercent(total, payload[0].value)})
          </div>
        </StyledContentTooltip>
      </StyledTooltipContainer>
    );
  }
  return null;
};

export default CustomTooltip;
